var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9178 4.8067C12.8558 4.74421 12.7821 4.69461 12.7008 4.66077C12.6196 4.62692 12.5325 4.6095 12.4445 4.6095C12.3565 4.6095 12.2693 4.62692 12.1881 4.66077C12.1068 4.69461 12.0331 4.74421 11.9711 4.8067L7.00447 9.78003L4.9178 7.6867C4.85345 7.62454 4.77749 7.57566 4.69425 7.54286C4.61102 7.51006 4.52213 7.49397 4.43268 7.49552C4.34323 7.49706 4.25495 7.51622 4.1729 7.55188C4.09085 7.58754 4.01662 7.63902 3.95447 7.70336C3.89231 7.76771 3.84343 7.84367 3.81063 7.92691C3.77782 8.01014 3.76174 8.09903 3.76329 8.18848C3.76483 8.27793 3.78399 8.36621 3.81965 8.44826C3.85531 8.53031 3.90678 8.60454 3.97113 8.6667L6.53113 11.2267C6.59311 11.2892 6.66684 11.3388 6.74808 11.3726C6.82932 11.4065 6.91646 11.4239 7.00447 11.4239C7.09247 11.4239 7.17961 11.4065 7.26085 11.3726C7.34209 11.3388 7.41582 11.2892 7.4778 11.2267L12.9178 5.7867C12.9855 5.72427 13.0395 5.6485 13.0764 5.56417C13.1133 5.47983 13.1324 5.38876 13.1324 5.2967C13.1324 5.20463 13.1133 5.11356 13.0764 5.02923C13.0395 4.94489 12.9855 4.86912 12.9178 4.8067Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4723911bc8ce2cb9197c6809738fd077.svg";
export { ForwardRef as ReactComponent };